import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/hooks/onboarding/portfolio/constants/uploadCopy";
import type { PortfolioUploadType } from "@/src/components/PortfolioScreenshotModal/types";

const I18n = I18nUtil.createScoped(Translations);

export type PortfolioUploadText = {
  title: string;
  subtitle: string;
  analyzeLabel: string;
  confirmLabel: string;
  formatErrorToast: string;
  oversizedToast: string;
  maxCountToast: string;
  maxCountTruncateToast: string;
};

export type GetPortfolioUploadTextParams = {
  uploadType: PortfolioUploadType;
  /** Reserved for future i18n; unused in placeholder copy. */
  locale?: string;
};

function buildPortfolioUploadTextForType(
  uploadType: PortfolioUploadType,
): PortfolioUploadText {
  if (uploadType === "pdf") {
    return {
      title: I18n.t("Upload PDF"),
      subtitle: I18n.t(
        "Upload PDF files to verify your assets (Maximum 5 files, 20MB each).",
      ),
      analyzeLabel: I18n.t("Analyze PDF"),
      confirmLabel: I18n.t("Confirm"),
      formatErrorToast: I18n.t(
        "Format not supported. Only PDF files are allowed.",
      ),
      oversizedToast: I18n.t("File too large (PDF ≤ 20MB)"),
      maxCountToast: I18n.t("You can only upload 5 files at a time"),
      maxCountTruncateToast: I18n.t(
        "Some files could not be uploaded because you can only upload 5 attachments at a time",
      ),
    };
  }

  return {
    title: I18n.t("Upload Image"),
    subtitle: I18n.t("Upload images to verify your assets (Maximum 5 images)."),
    analyzeLabel: I18n.t("Analyze Image"),
    confirmLabel: I18n.t("Confirm"),
    formatErrorToast: I18n.t(
      "Format not supported. Images: JPG, JPEG, PNG, HEIC, WebP.",
    ),
    oversizedToast: I18n.t("File too large (image ≤ 10MB)"),
    maxCountToast: I18n.t("You can only upload 5 images at a time"),
    maxCountTruncateToast: I18n.t(
      "Some files could not be uploaded because you can only upload 5 attachments at a time",
    ),
  };
}

/**
 * Portfolio upload modal copy resolved at call time (locale-ready for future i18n).
 */
export function getPortfolioUploadText({
  uploadType,
  locale: _locale,
}: GetPortfolioUploadTextParams): PortfolioUploadText {
  void _locale;
  return buildPortfolioUploadTextForType(uploadType);
}
